import styled from '@emotion/styled';
import { useContext } from 'react';

import Flex from 'components/Flex';

import { GameTypeEnum, GameDifficulty, OnlineOpponent } from 'graphql/types';

import SceneDetailModalTabPanelUnfinished from './SceneDetailModalTabPanelUnfinished';

import InviteUserWithoutPolling from './MatchView/MatchmakingButton/InviteUser/InviteUserWithoutPolling';
import MatchmakingButtonInModal from './MatchView/MatchmakingButton/MatchmakingButtonInModal';

import { StartMatchContext } from '../LobbyGame/StartMatchProvider';

interface SceneDetailModalPropsTab {
  isHidden: boolean;
  isPlayButtonDisabled: boolean;
  sceneId: string;
  gameType?: GameTypeEnum;
  opponentCount?: number;
  gameDifficulty: GameDifficulty;
  children?: React.ReactNode;
}
const SceneDetailModalTabPanel = ({
  isHidden,
  isPlayButtonDisabled,
  sceneId,
  gameType,
  opponentCount,
  gameDifficulty,
  children,
}: SceneDetailModalPropsTab) => {
  const { startMatchmaking } = useContext(StartMatchContext);

  if (!gameType) {
    // Unfinished games

    return (
      <TabPanel hidden={isHidden}>
        <TabPanelContent>
          <TabPanelContentBodySpace>
            <TabPanelContentBodySpaceContainer>
              <SceneDetailModalTabPanelUnfinished
                isVisible={!isHidden}
                sceneId={sceneId}
                gameDifficulty={gameDifficulty}
              />
            </TabPanelContentBodySpaceContainer>
          </TabPanelContentBodySpace>
        </TabPanelContent>
      </TabPanel>
    );
  }

  const handleStartMatchmaking = (opponent?: OnlineOpponent) => {
    startMatchmaking(sceneId, opponent, gameType);
  };

  return (
    <TabPanel hidden={isHidden}>
      <TabPanelContent>
        <TabPanelContentButtonSpace>
          <MatchmakingButtonInModal
            selectedSceneId={sceneId}
            disabled={isPlayButtonDisabled}
            opponentCount={opponentCount}
            gameType={gameType}
            gameDifficulty={gameDifficulty}
          />
        </TabPanelContentButtonSpace>

        <TabPanelContentBodySpace>
          <TabPanelContentBodySpaceContainer>
            <Flex justifyContent="center" css={{ height: '100%' }}>
              {children && (
                <Flex
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  css={{
                    height: '100%',
                    paddingInline: 20,
                    textAlign: 'center',
                    maxWidth:
                      gameDifficulty === GameDifficulty.MEDIUM
                        ? '50%'
                        : undefined,
                  }}
                >
                  {children}
                </Flex>
              )}
              {gameDifficulty === GameDifficulty.MEDIUM && (
                <div>
                  <InviteUserWithoutPolling
                    selectedSceneId={sceneId}
                    gameType={gameType}
                    onOpponentSelected={handleStartMatchmaking}
                    gameDifficulty={gameDifficulty}
                  />
                </div>
              )}
            </Flex>
          </TabPanelContentBodySpaceContainer>
        </TabPanelContentBodySpace>
      </TabPanelContent>
    </TabPanel>
  );
};

const TabPanel = styled('div')<{ hidden: boolean }>(({ hidden }) => ({
  position: 'relative',
  marginTop: 20,
  maxHeight: 270,
  minHeight: 270,
}));
const TabPanelContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
});
const TabPanelContentButtonSpace = styled('div')({
  position: 'relative',
});
const TabPanelContentBodySpace = styled('div')({
  height: '100%',
  position: 'relative',
});
const TabPanelContentBodySpaceContainer = styled('div')({
  position: 'absolute',
  top: 5,
  left: 0,
  right: 0,
  bottom: 0,
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: 7,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#d8d4fd',
    borderRadius: 3,
    border: '1px solid #d8d4fd',
  },
  '&::-webkit-scrollbar-track': {
    background: '#AAAAAA99',
  },
});

export default SceneDetailModalTabPanel;
